<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <!--<div class="col-md-12" v-if="getRoleType === 99">-->
        <!--<div class="box">-->
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">例外訂單列表</h3>-->
          <!--</div>-->
          <!--<div class="box-body">-->
            <!--<order-exception-table />-->
            <!--&lt;!&ndash; /.box-body &ndash;&gt;-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <div class="col-md-12">
        <div class="box">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">訂單列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body">
            <queryString-table />
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import orderTableTemp from './Temp/OrderTableTemp.vue'
import queryStringTemp from './Temp/QueryStringTemp.vue'
import orderExceptionTableTemp from './Temp/OrderExceptionTableTemp.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    payType (type) {
      if (type === 10) {
        return '線上支付'
      } else if (type === 50) {
        return '店家支付'
      }
    },
    payStateName (state) {
      if (state === 11) {
        return '尚未付款'
      } else if (state === 12) {
        return '付款處理中'
      } else if (state === 13) {
        return '已收款'
      } else if (state === 21) {
        return '退款處理中'
      } else if (state === 22) {
        return '已退款'
      }
    },
    orderState (state) {
      if (state === 0) {
        return '訂單尚未確認'
      } else if (state === 1) {
        return '訂單已送出，尚未付款'
      } else if (state === 2) {
        return '付款中'
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家'
      } else if (state === 99) {
        return '使用者取消訂單'
      } else if (state === 100) {
        return '未接單'
      } else if (state === 110) {
        return '已接單'
      } else if (state === 120) {
        return '被店家退訂'
      } else if (state === 121) {
        return '被系統退訂'
      } else if (state === 122) {
        return '已取消'
      } else if (state === 130) {
        return '已完成'
      } else if (state === 140) {
        return '已作廢'
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    }
  },
  components: {
    'order-table': orderTableTemp,
    'order-exception-table': orderExceptionTableTemp,
    'queryString-table': queryStringTemp
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    }
  }
  /*
  beforeRouteLeave (to, from, next) {
    var allSession = Object.keys(sessionStorage)
    var array = []
    allSession.map(function (c, i, a) {
      if (c.indexOf('orderTable') > -1) array.push(c)
    })
    array.forEach(function (key) {
      sessionStorage.removeItem(key)
    })
    next()
  }
  */
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
</style>



// WEBPACK FOOTER //
// menuquerystringview.vue?0074793a